export const VAT_VALID_RESPONSE_CODES: number[] = [200, 216, 218, 219, 223];

export const COULD_NOT_VALIDATE_RESPONSE_CODES: number[] = [205, 208, 999];
